export const URL_STS = () => {
  return `https://ai.experiencethenext.com${
    !!window.location.port ? ":" + window.location.port : ""
  }${process.env.REACT_APP_URL_STS}`;
};
export const URL_TRANSFORMER = () => {
  return `https://ai.experiencethenext.com${
    !!window.location.port ? ":" + window.location.port : ""
  }${process.env.REACT_APP_URL_TRANSFORMER}`;
};
